import { ProductionFulfillmentApi, useAPIAction } from "melco-shared-logic";

export const useDuplicateDesignMapping = (designMappingId: string) => {
  return useAPIAction(
    ProductionFulfillmentApi,
    async (api) => {
      const data = await api.productionFulfillmentMappingsDuplicate({
        id: designMappingId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    { translationPrefix: "designMappings.actions.duplicate" }
  );
};
